export default __webpack_public_path__ + "static/media/moreIcon.09d5089c.svg";